import React, {Component} from 'react';
import HeaderComponent from "../../../../Components/HeaderComponent/HeaderComponent";
import {
    Box,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Typography
} from "@material-ui/core";
import SubHeaderAward from "../SubHeaderAward/SubHeaderAward";
import SpacerComponent from "../../../../Components/SpacerComponent/SpacerComponent";
import ContentListAward from "../ContentListAward";
import SubHeaderComponent from "../../../../Components/SubHeaderDefault/SubHeaderComponent";
import ContentListEstablishment from "../../ManageEstablishmentScreen/ContentListEstablishment";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MessageUtil from "../../../../Utils/MessageUtil";
import AwardService from "../../../../Services/AwardService";
import DateUtil from "../../../../Utils/DateUtil";
import ExtractClientScreen from "../../ExtractClientScreen/ExtractClientScreen";

class InfoAwardScreen extends Component {
    static ROUTE = '/info-award';

    awardService;

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            erros: [],
            info: null,
            bookings: null,
            changes: null,
            amountChanges: null,
        };

        this.awardService = new AwardService();
    }

    componentDidMount() {
        this.load();
    }

    load = async () => {
        try {

            if (!this.props.match.params?.award) {
                return;
            }

            const awardUuid = this.props.match.params?.award;

            this.setState({
                inLoad: true,
            })

            const response = await this.awardService.getData(awardUuid);

            this.setState({
                inLoad: false,
                info: response.data.data,
                bookings: response.data.bookings,
                amountChanges: response.data.amount_changes,
                changes: response.data.changes,
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Error',
                    body: e,
                }),
            });
        }
    }

    render() {
        const info = this.state.info;
        const bookings = this.state.bookings;
        const changes = this.state.changes;
        const amountChanges = this.state.amountChanges;
        return (
            <div>
                <HeaderComponent title={'Informações do Prêmio'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                {this.state.info &&
                    <Box display={'flex'}
                         justifyContent={'center'}
                         alignItems={'center'}>
                        <Box width={'80%'}>
                            <SubHeaderComponent title={info.title}
                                                search={false}/>
                            <SpacerComponent height={60}/>

                            <Typography variant={'h6'}
                                        color={'primary'}>Cadastro</Typography>

                            <span>Data de Cadastro: {DateUtil.raw(info.created_at).toDate()}</span>
                            <SpacerComponent height={50}/>
                            <Typography variant={'h6'}
                                        color={'primary'}>Validade</Typography>
                            <spa>{DateUtil.raw(info?.start_validity).toDate()} - {DateUtil.raw(info?.end_validity).toDate()}
                            </spa>

                            <p><b>Histórico</b></p>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Data da modificação</TableCell>
                                            <TableCell>Usuário</TableCell>
                                            <TableCell>Usuário Email</TableCell>
                                            <TableCell>Val. Inicial Antiga</TableCell>
                                            <TableCell>Val. Final Nova</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            changes?.map(function (value, i) {
                                                return (
                                                    <TableRow key={i}>
                                                        <TableCell>{DateUtil.raw(value.created_at).toDateTime()}</TableCell>
                                                        <TableCell>{value.user.name}</TableCell>
                                                        <TableCell>{value.user.email}</TableCell>
                                                        <TableCell>{DateUtil.raw(value.old_start_date).toDate()}</TableCell>
                                                        <TableCell>{DateUtil.raw(value.old_end_date).toDate()}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <SpacerComponent height={50}/>

                            <Typography variant={'h6'}
                                        color={'primary'}>Estoque</Typography>

                            <p>Quantidade Cadastrada: {info.amount}</p>
                            <p>Quantidade por Filial</p>
                            <SpacerComponent height={12}/>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Filial</TableCell>
                                            <TableCell>Quantidade</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            info?.companies.map(function (value, i) {
                                                return (
                                                    <TableRow key={i}>
                                                        <TableCell>{value.name}</TableCell>
                                                        <TableCell>{value.amount}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <p><b>Histórico</b></p>
                            <SpacerComponent height={12}/>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Data da modificação</TableCell>
                                            <TableCell>Empresa</TableCell>
                                            <TableCell>Usuário</TableCell>
                                            <TableCell>Usuário Email</TableCell>
                                            <TableCell>Quantidade Antiga</TableCell>
                                            <TableCell>Quantidade Nova</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            amountChanges?.map(function (value, i) {
                                                return (
                                                    <TableRow key={i}>
                                                        <TableCell>{DateUtil.raw(value.created_at).toDateTime()}</TableCell>
                                                        <TableCell>{value.company.name}</TableCell>
                                                        <TableCell>{value.user.name}</TableCell>
                                                        <TableCell>{value.user.email}</TableCell>
                                                        <TableCell>{value.old_amount}</TableCell>
                                                        <TableCell>{value.new_amount}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <SpacerComponent height={50}/>

                            <Typography variant={'h6'}
                                        color={'primary'}>Reservas</Typography>
                            <SpacerComponent height={22}/>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Reservado Por</TableCell>
                                            <TableCell>Estabelecimento</TableCell>
                                            <TableCell>Quant.</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Data</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            bookings?.map(function (value, i) {
                                                return (
                                                    <TableRow key={i}>
                                                        <TableCell>
                                                            <a href={`${ExtractClientScreen.ROUTE}/${value.user.uuid}/${value.fidelity_program.uuid}`}>{value.user.name}</a>
                                                        </TableCell>
                                                        <TableCell>{value.company.name}</TableCell>
                                                        <TableCell>{value.amount}</TableCell>
                                                        <TableCell>{value.status}</TableCell>
                                                        <TableCell>{DateUtil.raw(value.created_at).toDateTime()}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                }
                <SpacerComponent height={40}/>
            </div>
        );
    }
}

export default InfoAwardScreen;